import { render } from "./MultiValueTag.vue?vue&type=template&id=21018640"
import script from "./MultiValueTag.vue?vue&type=script&lang=js"
export * from "./MultiValueTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__